import Theme from "../../../../utils/Theme";

export const PopupStyles = {
    tableStyle: { borderTop: "1px solid #d9d9d9" },
    tablebody: { padding: 0 },
    rowStyle: { backgroundColor: "white" },
    cellStyle: { color: "primary.main", borderBottom: "none" },
    childCell: { borderBottom: "none", },
    surveyCell: { borderBottom: "none", height: "5px" },

    mainBox: {
        justifyContent: "center",
        width: "100%",
        height: "100%",
        flexDirection: "column",
        alignItems: "center",
        overflow: "scroll",
        px: 2,
    },
    cardBox: {
        display: "flex",
        bgcolor: Theme.palette.secondary.main,
        p: 2,
        flexDirection: "row",
        justifyContent: "space-between",
        borderRadius: 2,
    },
    itemBox: { display: "flex", flexDirection: "column", gap: 1 },
    itemStyle: { fontWeight: "bold" },
    loadingStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        p: 10,
    },
}